import {
  Box,
  LinearProgress,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import React from "react";
import { visuallyHidden } from "@mui/utils";
import PropTypes from "prop-types";

const headCells = [
  {
    id: "_id",
    numeric: false,
    disablePadding: false,
    label: "Order ID",
  },
  {
    id: "username",
    numeric: false,
    disablePadding: false,
    label: "Customer",
  },
  {
    id: "orderReturnRequestDate",
    numeric: false,
    disablePadding: false,
    label: "Request Date",
  },
  {
    id: "orderReturnDate",
    numeric: false,
    disablePadding: false,
    label: "Return Date",
  },
  {
    id: "totalQTY",
    numeric: false,
    disablePadding: false,
    label: "Items",
  },
  {
    id: "price",
    numeric: false,
    disablePadding: false,
    label: "Price",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
];

const ReturnOrderRequestColumn = ({
  order,
  orderBy,
  onRequestSort,
  dataLoading,
}) => {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell></TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell></TableCell>
      </TableRow>
      {dataLoading && (
        <TableRow>
          <TableCell colSpan={9} sx={{ p: 0 }}>
            <LinearProgress />
          </TableCell>
        </TableRow>
      )}
    </TableHead>
  );
};

ReturnOrderRequestColumn.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default ReturnOrderRequestColumn;
